import { GetTimeConditionsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface TimeCondition {
  id?: number | null | undefined
  startOn: number
  duration: number
}

export const useGetTimeConditions = (legalEntityId: number) => {
  const { data, loading, error } = useQuery(GetTimeConditionsDocument, {
    variables: { legalEntityId: legalEntityId },
  })

  return {
    error,
    loading,
    timeConditions: data?.timeBalance?.timeConditionsConnection?.nodes,
  }
}
